import { MINI_LK_PAGE_PATHNAME_REGEXP } from "../constants/auth";

export const debounce = (
  targetFunction: () => Promise<unknown>,
  timeout = 0
) => {
  let resolvers: Array<(value: unknown) => void> = [];
  let timeoutId: number | null = null;

  const debouncedFunction = () => {
    if (timeoutId !== null) {
      clearTimeout(timeoutId);
    }

    timeoutId = window.setTimeout(() => {
      const result = targetFunction();

      resolvers.forEach((resolve) => resolve(result));
      resolvers = [];
    }, timeout);

    return new Promise((resolve) => resolvers.push(resolve));
  };

  return debouncedFunction;
};

export const decodeBase64String = (value: string) =>
  atob(value).split("\u0000").join("");

export const checkIsMiniLk = () =>
  MINI_LK_PAGE_PATHNAME_REGEXP.test(window.location.pathname);
